import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { checkPostcode, METRO_POSTCODES } from '../../data/mock';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { MapPin, Check, AlertCircle, ArrowRight } from 'lucide-react';

const ServiceAreaSection = () => {
  const [postcode, setPostcode] = useState('');
  const [result, setResult] = useState(null);
  const [email, setEmail] = useState('');
  const [interestSubmitted, setInterestSubmitted] = useState(false);

  const handleCheck = (e) => {
    e.preventDefault();
    if (postcode.length >= 4) {
      const checkResult = checkPostcode(postcode);
      setResult(checkResult);
    }
  };

  const handleInterestSubmit = (e) => {
    e.preventDefault();
    console.log('Interest registered:', { postcode, email });
    setInterestSubmitted(true);
  };

  return (
    <section className="section-padding bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          {/* Section Header */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#0D9488] text-white rounded-full text-sm font-medium mb-6">
            <MapPin className="w-4 h-4" />
            Phase 1 Service Area
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111]">
            Metro Melbourne LGAs only
          </h2>
          <p className="mt-4 text-lg text-[#475569]">
            We're focused on reliable metro service first. Check if your installation site 
            is within our service area.
          </p>

          {/* Postcode Checker */}
          <div className="mt-10 bg-white rounded-2xl p-8 border border-[#E2E8F0] shadow-sm">
            <form onSubmit={handleCheck} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <Input
                type="text"
                placeholder="Enter postcode (e.g., 3000)"
                value={postcode}
                onChange={(e) => {
                  setPostcode(e.target.value.replace(/\D/g, '').slice(0, 4));
                  setResult(null);
                  setInterestSubmitted(false);
                }}
                className="flex-1 h-12 text-center text-lg font-medium border-[#E2E8F0] focus:border-[#0D9488]"
              />
              <Button 
                type="submit" 
                className="bg-[#0D9488] hover:bg-[#0F766E] text-white h-12 px-8"
                disabled={postcode.length < 4}
              >
                Check
              </Button>
            </form>

            {/* Result */}
            {result && (
              <div className="mt-6 animate-fade-in">
                {result.isServiced ? (
                  <div className="postcode-result-success rounded-xl p-4 flex items-center justify-center gap-3">
                    <Check className="w-5 h-5" />
                    <span className="font-medium">{result.message}</span>
                  </div>
                ) : (
                  <div className="space-y-4">
                    <div className="postcode-result-fail rounded-xl p-4 flex items-center justify-center gap-3">
                      <AlertCircle className="w-5 h-5" />
                      <span className="font-medium">{result.message}</span>
                    </div>
                    
                    {!interestSubmitted ? (
                      <form onSubmit={handleInterestSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                        <Input
                          type="email"
                          placeholder="Your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="flex-1 h-11 border-[#E2E8F0]"
                          required
                        />
                        <Button 
                          type="submit"
                          variant="outline"
                          className="border-[#E2E8F0] text-[#111111] hover:border-[#0D9488]"
                        >
                          Register Interest
                        </Button>
                      </form>
                    ) : (
                      <p className="text-[#0D9488] font-medium">
                        Thanks! We'll notify you when we expand to your area.
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Link to full page */}
          <div className="mt-8">
            <Link 
              to="/service-area"
              className="inline-flex items-center gap-2 text-[#0D9488] hover:text-[#0F766E] font-medium transition-colors"
            >
              View full service area details
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaSection;
